/*
  KB Hover-Menü (Julien 2026-09-22, Vorbild westmark.de): Die Flyouts des
  Desktop-Menüs öffnen sich schon beim Überfahren mit der Maus, nicht erst
  beim Klick. Dawn baut die Flyouts als natives <details>; wir setzen nur
  dessen open-Attribut — Tastatur (Enter/Leertaste auf dem <summary>, Esc)
  und Touch (Tippen) funktionieren unverändert über Dawns eigene Logik.

  Nur für echte Zeiger (Maus/Trackpad): auf Touch-Geräten gibt es kein
  Hover, dort bleibt es beim Tippen. Beim Verlassen schließt das Flyout mit
  kurzer Verzögerung, damit die Maus diagonal in die Liste fahren kann,
  ohne dass sie zuklappt.
*/
(function () {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var CLOSE_DELAY = 180;
  var closers = [];

  function setup(menu, nav) {
    var details = menu.querySelector('details');
    var summary = details && details.querySelector('summary');
    if (!details || !summary) return;
    var timer = null;

    function open() {
      clearTimeout(timer);
      /* Nur ein Brett zur Zeit: andere offene Flyouts sofort schließen */
      closers.forEach(function (c) {
        if (c.menu !== menu) c.closeNow();
      });
      if (!details.open) {
        details.open = true;
        summary.setAttribute('aria-expanded', 'true');
      }
    }

    function closeNow() {
      clearTimeout(timer);
      if (!details.open) return;
      details.open = false;
      summary.setAttribute('aria-expanded', 'false');
    }

    function close() {
      clearTimeout(timer);
      timer = setTimeout(function () {
        if (menu.contains(document.activeElement) && document.activeElement !== summary) return;
        closeNow();
      }, CLOSE_DELAY);
    }

    closers.push({
      menu: menu,
      close: close,
      closeNow: closeNow,
      cancel: function () {
        clearTimeout(timer);
      },
    });

    menu.addEventListener('pointerenter', function (e) {
      if (e.pointerType === 'mouse') open();
    });
    /* Das Holzbrett hängt unter der ganzen Menüleiste (kb-header.css). Bricht
       die Leiste auf Laptop-Breite in zwei Zeilen um, fährt die Maus auf dem
       Weg ins Brett über die zweite Zeile — dort bleibt es offen. Geschlossen
       wird erst beim Verlassen der Leiste (siehe init) oder wenn ein anderer
       Punkt mit Unterpunkten aufklappt. */
    menu.addEventListener('pointerleave', function (e) {
      if (e.pointerType !== 'mouse') return;
      if (e.relatedTarget && nav.contains(e.relatedTarget)) return;
      close();
    });

    /* Mausklick auf den Menüpunkt selbst führt zur Kategorie, wie bei Punkten
       ohne Unterpunkte (Julien 2026-10: „auf Helfer in der Küche drücken
       können, genau wie bei Backen & Zubereiten"). Das Brett ist per Hover
       ohnehin schon offen. Tastatur (Enter, detail 0) und Touch klappen
       weiterhin nur das Brett auf. */
    summary.addEventListener('click', function (e) {
      if (e.pointerType === 'touch' || e.detail === 0) return;
      e.preventDefault();
      var ziel = summary.getAttribute('data-kb-href');
      if (ziel && ziel !== '#') window.location.href = ziel;
    });
  }

  function init() {
    var nav = document.querySelector('.header__inline-menu');
    if (!nav) return;
    nav.querySelectorAll('header-menu').forEach(function (menu) {
      setup(menu, nav);
    });
    nav.addEventListener('pointerleave', function (e) {
      if (e.pointerType !== 'mouse') return;
      closers.forEach(function (c) {
        c.close();
      });
    });
    /* 2026-10 (Julien): Wechsel auf einen anderen Hauptpunkt schließt das offene
       Brett sofort — auch wenn der neue Punkt selbst kein Brett hat (z. B.
       „Backen & Zubereiten", „Über mich"). Vorher blieb das alte Brett stehen,
       weil nur Punkte mit Unterpunkten das Schließen auslösten.
       Kurze Verweilzeit, damit das schnelle Überqueren der zweiten Menüzeile
       auf dem Weg ins Brett es nicht schließt. */
    var SWITCH_DELAY = 150;
    nav.querySelectorAll('.list-menu--inline > li').forEach(function (li) {
      var switchTimer = null;
      li.addEventListener('pointerenter', function (e) {
        if (e.pointerType !== 'mouse') return;
        clearTimeout(switchTimer);
        switchTimer = setTimeout(function () {
          closers.forEach(function (c) {
            if (!li.contains(c.menu)) c.closeNow();
          });
        }, SWITCH_DELAY);
      });
      li.addEventListener('pointerleave', function () {
        clearTimeout(switchTimer);
      });
    });
    /* Zurück in die Leiste innerhalb der Schließ-Verzögerung: offen lassen */
    nav.addEventListener('pointerenter', function (e) {
      if (e.pointerType !== 'mouse') return;
      closers.forEach(function (c) {
        c.cancel();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
